export const getLeadValueByKey = (leadData, key) => {
  if (!leadData) {
    return "";
  }

  const nestedFields = {
    desk_id: (lead) => lead.desk?.id?.toString() || "",
    affiliate: (lead) => lead.affiliator?.affiliate || "",
    geo: (lead) => lead.geo || "",
    sale_status: (lead) => lead.sale_status || "",
    reten_status: (lead) => lead.reten_status || "",
    manager_id: (lead) => lead.manager?.id?.toString() || "",
    affiliator_id: (lead) => lead.affiliator?.id?.toString() || "",
  };

  const displayedFields = {
    manager_id: (lead) => (lead.manager?.first_name ? `${lead.manager?.first_name} ${lead.manager?.last_name || ''}`.trim() : lead.manager?.email) || "",
    desk_id: (lead) => lead.desk?.name || "",
    affiliator_id: (lead) => (lead.affiliator?.first_name ? `${lead.affiliator?.first_name} ${lead.affiliator?.last_name || ''}`.trim() : lead.affiliator?.affiliate) || lead.affiliator?.email || "",
  };

  return displayedFields[key] 
    ? displayedFields[key](leadData) 
    : nestedFields[key] 
      ? nestedFields[key](leadData) 
      : leadData[key] ?? "";
};
